export default __webpack_public_path__ + "static/wrastajacy-paznokiec-1555183f52782279a0a507a06ddde2da.png";